import { FC } from 'react';
import Quicksight from '@components/quicksight/Quicksight';
import { useAppDispatch } from '@app/hooks/useReduxToolkit';
import { setQuicksightBoard } from 'state-services';

const GoldCard: FC = () => {
	const dispatch = useAppDispatch();
	dispatch(setQuicksightBoard('Gold Card'));
	// Passing as prop leads to cache issue where old board type is fetched along with new type.
	// Cached type req will fail showing the error box & then 2nd req completes showing data.
	// Dispatch to stay gets around this issue, preventing the 1st stale request.
	return (
		<>
			<Quicksight />
		</>
	);
};

export default GoldCard;
